import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p>
        This Privacy Policy explains how InfluencerCollab ("InfluencerCollab", "we", "us", or "our") collects,
        uses, and protects your information when you use our marketplace at influencercollab.net (the "Platform").
        By using the Platform you agree to the practices described below.
      </p>

      <Section heading="1. Information We Collect">
        <p>We collect the following types of information:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><strong>Account information</strong> via Google Sign-In: your name, email address and profile picture.</li>
          <li><strong>Profile information</strong> you provide: role (promoter or influencer), bio, categories, platforms, languages, location, country, city, follower counts, engagement rates, rates, portfolio links and social profiles.</li>
          <li><strong>Campaign & bid data</strong>: campaigns you post, bids you submit, messages and related content.</li>
          <li><strong>Usage data</strong>: basic technical information such as device, browser and interactions needed to operate the Platform.</li>
        </ul>
      </Section>

      <Section heading="2. How We Use Your Information">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>To create and manage your account and authenticate you via Google.</li>
          <li>To operate the marketplace — matching promoters with influencers, displaying profiles, campaigns and bids.</li>
          <li>To process campaign workflows, selections and the applicable platform processing fee.</li>
          <li>To communicate important updates about your campaigns and account.</li>
          <li>To maintain safety, prevent fraud and comply with legal obligations.</li>
        </ul>
      </Section>

      <Section heading="3. Google Sign-In">
        <p>
          We use Google OAuth solely to authenticate you. We request access only to your basic profile
          (name, email, profile picture). We do not receive your Google password, and we do not post to your
          Google account. You can revoke access at any time from your Google Account security settings.
        </p>
      </Section>

      <Section heading="4. Sharing of Information">
        <p>
          Your public profile details (such as name, role, categories and portfolio) are visible to other
          Platform users to enable discovery and collaboration. We do not sell your personal information. We may
          share data with service providers who help us run the Platform, or when required by law.
        </p>
      </Section>

      <Section heading="5. Data Retention & Security">
        <p>
          We retain your information for as long as your account is active or as needed to provide the service and
          meet legal requirements. We apply reasonable technical and organizational measures to protect your data,
          though no method of transmission or storage is completely secure.
        </p>
      </Section>

      <Section heading="6. Your Rights">
        <p>
          You may access, update or request deletion of your profile information at any time from your account,
          or by contacting us. Deleting your account removes your profile from the marketplace, subject to records
          we must retain for legal or transactional purposes.
        </p>
      </Section>

      <Section heading="7. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Material changes will be reflected by updating the
          "Last updated" date above. Continued use of the Platform constitutes acceptance of the updated policy.
        </p>
      </Section>

      <Section heading="8. Contact">
        <p>
          For any privacy questions or requests, contact us at{" "}
          <a href="mailto:support@influencercollab.net" className="text-brand-pink hover:opacity-70">support@influencercollab.net</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
